<template>
  <div class="modal-body">
    <div class="registration-errors" v-show="errorMessage">
      <div class="alert alert-danger">{{ errorMessage }}</div>
    </div>

    <!-- Registration Disabled -->
    <div class="text-center" v-if="conference?.registration_disabled">
      <h5 class="m-t-100">Registration for this event is closed</h5>

      <div class="m-t-30">
        <svg width="69" height="69" viewBox="0 0 69 69" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M50.3641 29.1356V15.8715C50.3641 7.11874 43.241 0 34.4941 0C25.7517 0 18.6359 7.11874 18.6359 15.8715V29.14C14.1861 33.3505 11.3938 39.2962 11.3938 45.8953C11.3938 58.6397 21.7585 69 34.5 69C47.2415 69 57.6062 58.6383 57.6062 45.8953C57.6062 39.2948 54.8153 33.3461 50.3641 29.1356ZM24.2939 15.87C24.2939 10.237 28.8714 5.65213 34.4941 5.65213C40.1257 5.65213 44.7047 10.237 44.7047 15.87V25.1923C41.6173 23.6699 38.1687 22.7891 34.5015 22.7891C30.8312 22.7891 27.3754 23.6714 24.2939 25.1967V15.87ZM34.5015 60.5761C26.405 60.5761 19.8235 53.9932 19.8235 45.8953C19.8235 37.7988 26.405 31.2174 34.5015 31.2174C42.5994 31.2174 49.1794 37.7988 49.1794 45.8953C49.1794 53.9918 42.5994 60.5761 34.5015 60.5761Z" fill="#626264"/>
          <path d="M25.6018 39.672L34.5894 51.079L46.1535 36.8621L34.5894 44.7369L25.6018 39.672Z" fill="#626264"/>
        </svg>
      </div>
    </div>

    <h4 v-if="conference.id === 5965" class="membership-title in-person-type-title">In-Person (Face to Face)</h4>

    <div v-if="settings.offlinePayments" class="offline-payment-info">
      <i class="fa-regular fa-circle-info offline-payment-info-icon"></i>

      <div class="offline-payment-info-text">
        You'll have the option to pay by credit card, purchase order or another method after completing
        registration form.
      </div>
    </div>

    <div v-if="conference.id === 7486" class="alert alert-warning" style="margin-bottom: 40px;">
      <div style="margin-bottom: 10px;">
        <span style="color: #bb4f1d; font-weight: 700;">If you are registering as a student volunteer, please go here to register:</span>
        <a href="https://nyasp.wildapricot.org/event-6226010" target="_blank">https://nyasp.wildapricot.org/event-6226010</a>
      </div>

      <div>
        <span style="color: #bb4f1d; font-weight: 700;">If you are paying by a purchase order (PO) please go here to register:</span>
        <a href="https://nyasp.wildapricot.org/event-6208037" target="_blank">https://nyasp.wildapricot.org/event-6208037</a>
      </div>
    </div>

    <div v-if="conference.id === 8833" class="alert alert-warning" style="margin-bottom: 40px;">
      <div style="margin-bottom: 10px;">
        <span style="color: #000; font-weight: 700;">If you're paying with a purchase order, complete the P.O. google form in addition to event registration. P.O. Google Form:</span>
        <a href="https://forms.gle/soS7Kx86enwHCdZ99" target="_blank">https://forms.gle/soS7Kx86enwHCdZ99</a>
      </div>
    </div>

    <div v-if="conference.id === 9046" class="alert alert-warning" style="margin-bottom: 40px;">
      <div style="margin-bottom: 10px;">
        <span style="color: #000; font-weight: 700;">If you're paying with a purchase order, complete the P.O. google form in addition to event registration. P.O. Google Form:</span>
        <a href="https://forms.gle/BucxBK1J1Z8FiMh19" target="_blank">https://forms.gle/BucxBK1J1Z8FiMh19</a>
      </div>
    </div>

    <!-- Category selector (shown when backend provides ticket_categories) -->
    <div v-if="hasCategories" class="attendance-type-step">
      <div class="attendance-type-heading">
        <h4 class="attendance-type-heading__title">Please select your registration type</h4>
      </div>

      <div class="attendance-type-actions attendance-type-actions--wrap">
        <button
          v-for="category in ticketCategories"
          :key="category.id"
          type="button"
          class="attendance-type-card"
          :class="{ active: selectedCategory && selectedCategory.id === category.id }"
          @click="selectCategory(category)"
        >
          <span class="attendance-type-card__icon">
            <i class="fa-regular fa-tag"></i>
          </span>
          <span class="attendance-type-card__content">
            <span class="attendance-type-card__title">{{ category.title }}</span>
            <span v-if="category.description" class="attendance-type-card__description">{{ category.description }}</span>
          </span>
        </button>
      </div>
    </div>

    <!-- REPLACE START: attendance type selector + filtered tickets -->
    <div v-if="hasBothTicketTypes" class="attendance-type-step">
      <div class="attendance-type-heading">
        <h4 class="attendance-type-heading__title">How will you attend the event?</h4>
      </div>

      <div class="attendance-type-actions">
        <button
          type="button"
          class="attendance-type-card"
          :class="{ active: selectedAttendanceType === 'inperson' }"
          @click="selectAttendanceType('inperson')"
        >
          <span class="attendance-type-card__icon">
            <i class="fa-regular fa-user"></i>
          </span>
          <span class="attendance-type-card__content">
            <span class="attendance-type-card__title">In-Person</span>
            <span class="attendance-type-card__description">Attend on-site</span>
          </span>
        </button>

        <button
          type="button"
          class="attendance-type-card"
          :class="{ active: selectedAttendanceType === 'virtual' }"
          @click="selectAttendanceType('virtual')"
        >
          <span class="attendance-type-card__icon">
            <i class="fa-regular fa-globe"></i>
          </span>
          <span class="attendance-type-card__content">
            <span class="attendance-type-card__title">Virtual</span>
            <span class="attendance-type-card__description">Attend online</span>
          </span>
        </button>
      </div>
    </div>

    <div v-if="visibleTickets.type" :key="`tickets-${visibleTickets.type}`">
<!--      <h4-->
<!--        v-if="visibleTickets.type === 'inperson'"-->
<!--        class="membership-title in-person-type-title"-->
<!--      >-->
<!--        In-Person <i class="fa-regular fa-user default-color"></i>-->
<!--      </h4>-->

<!--      <h4-->
<!--        v-if="visibleTickets.type === 'virtual'"-->
<!--        class="membership-title live-streamed-type-title"-->
<!--      >-->
<!--        Live-Streamed <i class="fa-regular icon-globe default-color"></i>-->
<!--      </h4>-->

      <div
        v-for="(ticket, index) in visibleTickets.items"
        :key="`${visibleTickets.type}-${ticket.id}`"
      >
        <ticket
          :type="visibleTickets.type"
          :ticket="ticket"
          :index="index"
          :donation.sync="donation"
        />
      </div>
    </div>
    <!-- REPLACE END: attendance type selector + filtered tickets -->

<!--    &lt;!&ndash; In-Person Tickets &ndash;&gt;-->
<!--    <h4-->
<!--      v-if="tickets.inperson.length && tickets.virtual.length"-->
<!--      class="membership-title in-person-type-title"-->
<!--    >In-Person <i class="fa-regular fa-user default-color"></i></h4>-->

<!--    <fragment v-for="(ticket, index) in tickets.inperson" :key="`inperson-${index}`">-->
<!--      <ticket-->
<!--        type="inperson"-->
<!--        :ticket="ticket"-->
<!--        :index="index"-->
<!--        :donation.sync="donation"-->
<!--      />-->
<!--    </fragment>-->


<!--    &lt;!&ndash; Virtual Tickets &ndash;&gt;-->
<!--    <h4-->
<!--      v-if="tickets.inperson.length && tickets.virtual.length"-->
<!--      class="membership-title live-streamed-type-title"-->
<!--    >Live-Streamed <i class="fa-regular icon-globe default-color"></i></h4>-->

<!--    <fragment v-for="(ticket, index) in tickets.virtual" :key="`virtual-${index}`">-->
<!--      <ticket-->
<!--        type="virtual"-->
<!--        :ticket="ticket"-->
<!--        :index="index"-->
<!--        :donation.sync="donation"-->
<!--      />-->
<!--    </fragment>-->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Ticket from "./Ticket.vue";

export default {
  components: {
    Ticket
  },

  data() {
    return {
      selectedAttendanceType: null,
      selectedCategory: null
    };
  },

  computed: {
    ...mapGetters("basketStore", [
      "conference",
      "tickets",
      "ticketCategories",
      "settings",
      "errorMessage"
    ]),

    hasInPersonTickets() {
      return this.tickets?.inperson?.length > 0;
    },

    hasVirtualTickets() {
      return this.tickets?.virtual?.length > 0;
    },

    hasBothTicketTypes() {
      return this.hasInPersonTickets && this.hasVirtualTickets;
    },

    hasCategories() {
      return this.ticketCategories?.length > 0;
    },

    visibleTickets() {
      let type, items;

      if (this.hasBothTicketTypes) {
        type = this.selectedAttendanceType;
        items = this.tickets[this.selectedAttendanceType] || [];
      } else if (this.hasInPersonTickets) {
        type = "inperson";
        items = this.tickets.inperson;
      } else if (this.hasVirtualTickets) {
        type = "virtual";
        items = this.tickets.virtual;
      } else {
        return { type: null, items: [] };
      }

      // Filter by selected category when categories exist
      if (this.hasCategories && this.selectedCategory) {
        items = items.filter(t => t.ticket_category_id === this.selectedCategory.id);
      }

      return { type, items };
    }
  },

  watch: {
    hasBothTicketTypes: {
      immediate: true,
      handler() {
        this.selectedAttendanceType = this.getDefaultAttendanceType();
      }
    },

    hasInPersonTickets() {
      if (!this.selectedAttendanceType) {
        this.selectedAttendanceType = this.getDefaultAttendanceType();
      }
    },

    hasVirtualTickets() {
      if (!this.selectedAttendanceType) {
        this.selectedAttendanceType = this.getDefaultAttendanceType();
      }
    },

    // Auto-select the first category when categories are loaded
    hasCategories: {
      immediate: true,
      handler(val) {
        if (val && !this.selectedCategory) {
          this.selectedCategory = this.ticketCategories[0] || null;
        }
      }
    }
  },

  methods: {
    ...mapActions("basketStore", ["updateBasket"]),

    getDefaultAttendanceType() {
      if (this.hasBothTicketTypes) {
        return this.selectedAttendanceType || "inperson";
      }

      if (this.hasInPersonTickets) {
        return "inperson";
      }

      if (this.hasVirtualTickets) {
        return "virtual";
      }

      return null;
    },

    // resetTicketsByType(type) {
    //   const ticketList = this.tickets[type] || [];
    //
    //   ticketList.forEach((ticket) => {
    //     ticket.selected = 0;
    //
    //     if (ticket.addons && ticket.addons.length) {
    //       ticket.addons.forEach((addon) => {
    //         addon.selected = 0;
    //       });
    //     }
    //   });
    // },

    selectAttendanceType(type) {
      if (this.selectedAttendanceType === type) {
        return;
      }

      // const oppositeType = type === "inperson" ? "virtual" : "inperson";

      this.selectedAttendanceType = type;
      // this.resetTicketsByType(oppositeType);
      //
      // this.$nextTick(() => {
      //   this.updateBasket({
      //     tickets: this.tickets
      //   });
      // });
    },

    selectCategory(category) {
      if (this.selectedCategory && this.selectedCategory.id === category.id) {
        return;
      }
      this.selectedCategory = category;
    }
  }
}
</script>

<style lang="scss" scoped>
.offline-payment-info {
  display: flex;
  align-items: center;
  gap: 10px;

  margin-bottom: 20px;
  padding: 12px 14px;

  background: #f8f7fa;
  border: 1px solid #e4e2ea;
  border-radius: 0.25rem;
}

.offline-payment-info-icon {
  flex-shrink: 0;
  margin-top: 2px;
  font-size: 15px;
}

.offline-payment-info-text {
  margin: 0;
  font-family: Roboto, sans-serif;
  font-weight: 500;
}

.attendance-type-step {
  position: sticky;
  top: -16px;
  z-index: 20;

  margin: 0 0 25px;
  padding: 15px;
  border: 1px solid #DFDFDF;
  //border: 3px solid rgb(59, 100, 173);
  border-radius: 0.25rem;
  background: #F7F7F7;
  overflow: hidden;
}

.attendance-type-heading {
  margin-bottom: 10px;
}

.attendance-type-heading__title {
  margin: 0 0 4px;
  text-align: center;
  font-size: 21px;
  font-weight: 600;
  line-height: 1.25;
  color: #23262b;
}

.attendance-type-heading__text {
  margin: 0;
  font-size: 14px;
  color: #6f7782;
}

.attendance-type-actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(220px, 1fr));
  gap: 12px;

  // Category selector may have 3+ items — allow wrapping
  &--wrap {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
}

.attendance-type-card {
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  padding: 10px 10px;
  border: 1px solid #d9dee8;
  border-radius: 0.25rem;
  background: #fff;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s ease;
}

.attendance-type-card:hover {
  border-color: #4d90fd;
  //box-shadow: 0 4px 14px rgba(77, 144, 253, 0.12);
}

.attendance-type-card.active {
  border-color: #4d90fd;
  background: #f4f8ff;
  //box-shadow: 0 4px 14px rgba(77, 144, 253, 0.16);
}

.attendance-type-card__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 42px;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: #eef4ff;
  color: #4d90fd;
  font-size: 18px;
}

.attendance-type-card__content {
  display: flex;
  flex-direction: column;
}

.attendance-type-card__title {
  font-size: 16px;
  font-weight: 600;
  color: #2f2f35;
}

.attendance-type-card__description {
  font-size: 13px;
  color: #7a7f87;
}

@media (max-width: 767px) {
  .attendance-type-heading__title {
    font-size: 16px;
    line-height: 1.15;
    margin-bottom: 2px;
  }

  .attendance-type-heading__text {
    font-size: 11px;
    line-height: 1.2;
  }

  .attendance-type-actions {
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }

  .attendance-type-card {
    gap: 8px;
    padding: 8px 10px;
    border-radius: 8px;
  }

  .attendance-type-card__icon {
    min-width: 30px;
    width: 30px;
    height: 30px;
    font-size: 13px;
  }

  .attendance-type-card__title {
    font-size: 13px;
    line-height: 1.15;
  }

  .attendance-type-card__description {
    font-size: 10px;
    line-height: 1.15;
  }
}
</style>
